var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css, nothing } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { ref, createRef } from 'lit/directives/ref.js';
import { GetUserProfile } from '../screenshot/api';
import { GetLocalUserInfo, GetUserInfoInExtension, IsInExtension, RemoveLocalUserInfo } from '../user-info';
import { LogMessage } from '../helper-func';
import Constants, { EventNames } from '../constants';
import './grabit-dialog';
let UserProfile = class UserProfile extends LitElement {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.userData = null;
        this.error = null;
        this.dialogRef = createRef();
    }
    static { this.styles = css `
    :host {
      display: block;
      font-family: Arial, sans-serif;
      background-color: #f0f0f0;
      border-radius: 8px;
      text-align: center;
      max-width: 400px;
      margin: 0 auto;
    }
    .title {
      text-align: center;
      font-weight: bold;
    }
    .profile-content {
      margin: auto;
      padding-bottom: 5px;
    }
    .profile-icon {
      width: 120px;
      height: 120px;
      border-radius: 50%;
    }

    .subscription-status {
      color: #9b0000;
      font-size: 1.2em;
      text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
    }
    .quota-info-header {
      color: #333366;
      font-size: 1.1em;
      text-align: center;
    }
    .quota-info {
      color: #333366;
      font-size: 1em;
      text-align: center;
    }

    .button-container {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
      gap: 20px;
    }

    .buy-button {
      background-color: #e53935;
      color: white;
      border: none;
      border-radius: 50px;
      padding: 12px 5px;
      font-size: 1.1em;
      cursor: pointer;
      flex: 1;
    }

    .signout-button {
      background-color: #e0e0e0;
      color: #9b0000;
      border: 1px solid #ccc;
      border-radius: 50px;
      padding: 12px 5px;
      font-size: 1.1em;
      cursor: pointer;
      flex: 1;
    }

    .loading {
      display: inline-block;
      width: 50px;
      height: 50px;
      border: 5px solid rgba(0, 0, 0, 0.1);
      border-radius: 50%;
      border-top-color: #3498db;
      animation: spin 1s ease-in-out infinite;
      margin: 30px auto;
    }

    @keyframes spin {
      to { transform: rotate(360deg); }
    }
  `; }
    connectedCallback() {
        super.connectedCallback();
        this._fetchUserProfile();
    }
    open() {
        LogMessage('UserProfile.open called');
        this.dialogRef.value?.openDialog();
    }
    close() {
        this.dialogRef.value?.closeDialog();
    }
    clearUserProfile() {
        this.loading = false;
        this.userData = null;
        this.error = null;
    }
    fetchUserProfile() {
        this._fetchUserProfile();
    }
    _callUserProfileAPI(token) {
        this.loading = true;
        LogMessage(`UserProfile._callUserProfileAPI: token ${token}`);
        GetUserProfile({ token }, (success, data) => {
            LogMessage(`UserProfile._callUserProfileAPI: ${success} ${JSON.stringify(data)}`);
            if (!success) {
                this.error = 'Fetch user profile failure.';
                return;
            }
            this.userData = data;
            this.loading = false;
            const event = new CustomEvent(EventNames.UserProfileUpdated, {
                detail: this.userData,
                bubbles: true,
                composed: true,
            });
            LogMessage('dispatch user-profile-updated event');
            this.dispatchEvent(event);
        });
    }
    _fetchUserProfile() {
        if (IsInExtension()) {
            GetUserInfoInExtension((success, userInfo) => {
                LogMessage(`_fetchUserProfile from extension: ${success} ${JSON.stringify(userInfo)}`);
                if (success && userInfo) {
                    this._callUserProfileAPI(userInfo.userToken);
                }
                else {
                    this.error = 'No userToken in chrome local storage.';
                }
            });
        }
        else {
            const token = GetLocalUserInfo()?.userToken;
            LogMessage(`fetchUserProfile to get userinfo: ${token}`);
            if (token) {
                this._callUserProfileAPI(token);
            }
            else {
                this.error = "No userToken from local user info.";
            }
        }
    }
    handleBuyQuota() {
        // Implement buy quota functionality
        LogMessage('handleBuyQuota in user profile');
        // In extension, absolute URL is required.
        window.open(Constants.WEB_SERVER + 'buy_quota.html', "_blank");
    }
    handleSignOut() {
        LogMessage('handleSignOut in user profile');
        if (!IsInExtension()) {
            RemoveLocalUserInfo();
        }
        this.dispatchEvent(new CustomEvent(EventNames.UserSignedOut, { bubbles: true, composed: true }));
        this.close();
    }
    render() {
        if (!this.dialogRef) {
            return nothing;
        }
        let content = null;
        if (this.loading) {
            content = html `<div class="loading"></div>`;
        }
        else if (this.error) {
            content = html `<div class="error">Error: ${this.error}</div>`;
        }
        else if (!this.userData) {
            content = html `<div>No user data available</div>`;
        }
        let title = html `<span>Welcome ${this.userData?.user_name}</span>`;
        if (content != null) {
            return html `
        <grabit-dialog>
          <div class="title" slot="title">${title}</div>
          ${content}
        </grabit-dialog>
      `;
        }
        const { icon_url, user_name, used_free_quota, free_quota, free_screenshots, used_paid_quota, paid_quota, paid_screenshots, current_cycle_end_time, last_cycle_end_time, } = this.userData;
        // Has subscription
        let subscription = html `<div class="subscription-status">No Paid Subscription.</div>`;
        if (paid_quota != undefined && paid_quota > 0) {
            subscription = html `
        <div class="subscription-status">
          Last Subscription Cycle until ${new Date(last_cycle_end_time).toLocaleDateString()}
        </div>
        <div class="subscription-status">
          Current Subscription Cycle until ${new Date(current_cycle_end_time).toLocaleDateString()}
        </div>
      `;
        }
        return html `
      <grabit-dialog ${ref(this.dialogRef)}>
        <div class="title" slot="title">${title}</div>
        <div class="profile-content">
          <img class="profile-icon" src="${icon_url}" alt="User Profile" style="width:60px;height:60px;"/>
          ${subscription}
          <hr/>
          <div class="quota-info-header">Quota in this cycle:</div>
          <div class="quota-info">
            Free Quota used: ${used_free_quota} / ${free_quota} Screenshots: ${free_screenshots}
          </div>
          ${paid_quota != undefined && paid_quota > 0 ?
            html `
            <div class="quota-info">
              Paid Quota used: ${used_paid_quota} / ${paid_quota} Screenshots: ${paid_screenshots}
            </div>
            `
            :
                nothing}
          <div class="button-container">
            <button class="buy-button" @click=${this.handleBuyQuota}>Buy Quota</button>
            <button class="signout-button" @click=${this.handleSignOut}>Sign Out</button>
          </div>
        </div>
      </grabit-dialog>
    `;
    }
};
__decorate([
    state()
], UserProfile.prototype, "loading", void 0);
__decorate([
    state()
], UserProfile.prototype, "userData", void 0);
__decorate([
    state()
], UserProfile.prototype, "error", void 0);
UserProfile = __decorate([
    customElement('user-profile')
], UserProfile);
export { UserProfile };
